
const categoryFontMapping = {
  'common_pitch': 'V',
  'amusement_park': '(',
  'brewery': 'm',
  'castle': '%',
  'distributor': 'j',
  'farm': '&',
  'funicular': 'W',
  'golf_course': ')',
  'lake': 'd',
  'marina': '=',
  'museum': '*',
  'nature_park': '$',
  'outlet_center': 'e',
  'restaurant': '"',
  'ski_lift': 'i',
  'tank_station': '!',
  'thermal_bath': 'x',
  'vintner': '#',
  'water_park': '\'',
  'near_camping': '?',
};

const categoryNameMapping = {
  'common_pitch': 'Allgemeiner Stellplatz',
  'amusement_park': 'Freizeitpark',
  'brewery': 'Brauerei',
  'castle': 'Schloss/Burg',
  'distributor': 'Reisemobil-Hersteller oder Händler',
  'farm': 'Bauernhof',
  'funicular': 'Seilbahn',
  'golf_course': 'Golfplatz',
  'lake': 'Badesee',
  'marina': 'Hafen/Marina',
  'museum': 'Kultur-/Technikmuseum',
  'nature_park': 'Naturpark',
  'outlet_center': 'Outlet-Center',
  'restaurant': 'Restaurant',
  'ski_lift': 'Skilift',
  'tank_station': 'Tankstelle',
  'thermal_bath': 'Thermalbad',
  'vintner': 'Winzer/Weingut',
  'water_park': 'Freizeit-/Erlebnisbad',
  'near_camping': 'Stellplatz vor Campingplatz',
};

const versorgung = [
  "Stromanschlüsse",
  "Frischwasser",
  "WC",
  "Dusche",
  "Chemietoiletten-Entsorgung",
  "Grauwasser-Entsorgung",
  "Müll-Entsorgung",
];

const austattung = [
  "Einrichtungen für Kinder",
  "Rollstuhlgerecht",
  "Hunde erlaubt",
  "WLAN-Hotspot",
  "Gasflaschentausch",
  "Schwimmbad",
  "Hallenbad",
  "Liegewiese",
  "Grillplatz",
  "Fahrradverleih",
  "Restaurants",
];

const underground = [
  "Schotterrasen",
  "Wiese",
  "Asphalt",
  "Rasengittersteine",
  "Pflaster",
  "Schotter",
  "Kiesel",
  "Sand/Splitt",
  "Naturboden",
  "Eco-Raster/Gras",
];

const interests = {
  Genuss: {
    Restaurant: "a",
    Winzer: "b",
    Brauereien: "c",
    Genussreise: "",
  },
  "Wellness & Gesundheit": {
    Thermen: "",
    Wellness: "",
    Gesundheit: "",
  },
  "Kultur & Geschichte": {
    "Schlösser und Burgen": "",
    Museen: "",
    Städte: "",
    Kulturreise: "",
  },
  "Schwimmen & Baden": {
    "Freizeit-/Erlebnisbad": "",
    Badesee: "",
    Meer: "",
    Badeurlaub: "",
  },
  "Sport und Spaß": {
    Seilbahn: "p",
    Skilift: "l",
    Golfen: "l",
    Freizeitpark: "p",
    Yachthafen: "",
    Angeln: "",
    Klettern: "",
    Radfahren: "",
    Mountainbiking: "",
    Wandern: "",
    Wassersport: "",
    Wintersport: "",
    Sporturlaub: "",
  },
  "Naturnah übernachten": {
    Bauernhof: "",
    Naturpark: "",
    "Im Grünen": "",
    Naturnah: "",
    "Urlaub am Fluss": "",
  },
};

const searchDefaultValueFilter = {
  features: [],
  underground: [],
  interests: [],
  typePitch: true,
  typeService: false,
  typePitchEntsorgung: false,
  gespanneErlaubt: false,
  voucher: false,
  price: { lower: 0, upper: 30 },
  vehicle_length: { lower: 4, upper: 15 },
  noofpitches: { lower: 1, upper: 40 },
  ve: 0,
};


const routeDefaultValueFilter = {
  features: [],
  underground: [],
  interests: [],
  typePitch: true,
  typeService: false,
  typePitchEntsorgung: false,
  gespanneErlaubt: false,
  voucher: false,
  price: { lower: 0, upper: 30 },
  vehicle_length: { lower: 4, upper: 15 },
  noofpitches: { lower: 1, upper: 40 },
  ve: 0,
};

const Constants = {
  categoryFontMapping,
  categoryNameMapping,
  versorgung,
  austattung,
  underground,
  interests,
  routeDefaultValueFilter,
};

export default Constants;
